import TailComponent from "app/assets/svg/Tail";
import BlankAvatar from "app/assets/images/blank_avatar.png";
import sanitizeHtml from "sanitize-html";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { useEffect, useMemo, useRef } from "react";

export default function MessageCard({
  id,
  isIncomingMsg,
  content,
  className,
  createdAt,
  isSearch = false,
  handleMessageSelected,
  ...rest
}) {
  const options = { allowedTags: ["br"] };
  const sanitizedContent = sanitizeHtml(content, options);
  const [searchParams] = useSearchParams();
  const msgId = searchParams.get('msgId')
  const ref = useRef()
  useEffect(() => {
    if (msgId) {
      ref?.current?.scrollIntoView({ block: "center", behavior: "smooth" })
    }
  }, [msgId]);

  const highlight = useMemo(() => msgId === id, [msgId, id]);

  return (
    <div
      ref={ref}
      className={`${isSearch && "border-b border-[#001C4F] cursor-pointer pb-3"} ${highlight && 'bg-yellow-100'}`}
      onClick={() => isSearch ? handleMessageSelected(id) : {}}
      id={id}
    >
      <div
        {...rest}
        className={`flex gap-4 ${
          !isIncomingMsg && "flex-row-reverse"
        } ${className}`}
      >
        <div className="flex flex-col flex-[0_0_40px] justify-end">
          <img
            className="h-[40px] w-[40px] object-cover rounded-full"
            src={BlankAvatar}
            alt=""
          />
        </div>
        <div
          className={`relative ${
            isIncomingMsg
              ? "bg-[#FF8AB4] rounded-br-2xl"
              : "bg-[#97DDFF] rounded-bl-2xl"
          } rounded-t-2xl px-4 py-2 text-white`}
        >
          <div className="break-all" dangerouslySetInnerHTML={{__html: sanitizedContent}}/>
          <TailComponent
            className={`absolute ${
              isIncomingMsg
                ? "left-[-10px]"
                : "right-[-10px] revert-tail"
            } bottom-[0px] w-4 h-4`}
          />
        </div>
        <div className="flex-[0_0_40px]"/>
      </div>
      {isSearch && (
        <div className="text-sm text-[#ababac] pt-2">
          {moment(createdAt).format("YYYY-MM-DD H:s")}
        </div>
      )}
    </div>
  );
}
